import { Typography } from '@mui/material';
import { Dialog, DialogActionsWithButtons, DialogContent } from '@side/pantry';
import { useContext } from 'react';
import { UnsavedChangesContext } from './UnsavedChangesContext';

export const UnsavedChangesDialog = () => {
  const {
    cancelButtonText,
    dialogBody,
    dialogTitle,
    isDialogOpen,
    onCancel,
    onContinue,
    submitButtonText,
  } = useContext(UnsavedChangesContext);

  return (
    <Dialog
      onClose={() => {
        onCancel();
      }}
      maxWidth="sm"
      open={isDialogOpen}
    >
      <DialogContent title={dialogTitle} onClose={onCancel}>
        <Typography variant="body1">{dialogBody}</Typography>
      </DialogContent>

      <DialogActionsWithButtons
        CancelButtonProps={{
          buttonText: cancelButtonText,
          onClick: onCancel,
        }}
        SubmitButtonProps={{
          defaultText: submitButtonText,
          onClick: onContinue,
          color: 'error',
        }}
      />
    </Dialog>
  );
};
